import AdvanceReturnedPartInfoTab from './advance-returned-part-info';
import ReturnedPartInfoTab from './returned-part-analysis';

export default {
    childRoutes: [
        AdvanceReturnedPartInfoTab,
        ReturnedPartInfoTab
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/rga/results')
    },
    name: 'Part Request Results',
    path: 'rga'
};



// WEBPACK FOOTER //
// ./src/routes/rga/recalled-part-tab.js